export default {
  route: {
    home: 'Home',
    whoWeAre: 'Who We Are',
    pricing: 'Pricing / Signup',
    faq: 'FAQ',
    contact: 'Contact',
    login: 'Login',
    logout: 'Log Out',
    library: 'Video Library',
    checkout: 'Checkout',
    speakerBios: 'Speaker Bios',
    findACounselor: 'Find A Counselor',
    myChurch: 'My Church',
    notFound: 'Page not found',
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions'
  },
  checkout: {
    errorCard: {
      title: 'The following fields appear to be invalid:',
      number: 'card number',
      month: 'month',
      year: 'year',
      first_name: 'first name',
      last_name: 'last name'
    }
  }
}
